module.exports = __webpack_public_path__ + "img/logo3.81d22c6b.png";